import { createFileRoute } from '@tanstack/react-router';
import { locationsQuery } from '@/features/devices/api';
import { ReferenceListPage } from '@/features/devices/pages/ReferenceListPage';

/** "Qurilma joylashgan o'rni" (582:14120, create panel 586:15488). `?panel=new|<id>` opens the side panel. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/devices/locations')({
  validateSearch: (search: Record<string, unknown>): { panel?: string } => ({
    panel: typeof search.panel === 'string' && search.panel ? search.panel : undefined,
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(locationsQuery(context.tenant.id));
  },
  component: DeviceLocationsRoute,
});

function DeviceLocationsRoute() {
  const { tenant } = Route.useRouteContext();
  const { panel } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReferenceListPage
      tenant={tenant}
      kind="locations"
      panel={panel}
      onPanel={(next) => void navigate({ search: (prev) => ({ ...prev, panel: next }) })}
    />
  );
}
